export const createAuth = (getState) => {
    return{
        username: getState()["authState"].orgId,
        password: getState()["authState"].apiKey
    }
}